module.exports = __webpack_public_path__ + "8cfbfb8167d6622af054f3b65459f8fb.svg";